/**
 * This is a generated file. Do not edit directly
 */

export const size25 = "4px";
export const size50 = "8px";
export const size75 = "12px";
export const size100 = "16px";
export const size150 = "20px";
export const size200 = "24px";
export const size300 = "32px";
export const size350 = "40px";
export const size375 = "44px";
export const size400 = "48px";
export const size500 = "64px";
export const size525 = "80px";
export const size600 = "128px";
export const size700 = "256px";
export const size750 = "384px";
export const size800 = "512px";
export const size850 = "768px";
export const size900 = "1024px";
export const sizeCheckboxSmall = "14px";
export const sizeCheckboxMedium = "18px";
export const sizeCheckboxLarge = "22px";
export const sizeRadioSmall = "12px";
export const sizeRadioMedium = "16px";
export const sizeRadioLarge = "20px";
export const sizeIconTinyWidth = "12px";
export const sizeIconTinyHeight = "12px";
export const sizeIconTinyMargin = "2px";
export const sizeIconTinyStrokeWidth = "2.5px";
export const sizeIconSmallWidth = "16px";
export const sizeIconSmallHeight = "16px";
export const sizeIconSmallMargin = "4px";
export const sizeIconSmallStrokeWidth = "2px";
export const sizeIconMediumWidth = "24px";
export const sizeIconMediumHeight = "24px";
export const sizeIconMediumMargin = "4px";
export const sizeIconMediumStrokeWidth = "1.5px";
export const sizeIconDefaultWidth = "24px";
export const sizeIconDefaultHeight = "24px";
export const sizeIconDefaultMargin = "4px";
export const sizeIconDefaultStrokeWidth = "1.5px";
export const sizeIconLargeWidth = "32px";
export const sizeIconLargeHeight = "32px";
export const sizeIconLargeMargin = "8px";
export const sizeIconLargeStrokeWidth = "1.35px";
export const sizeIconHugeWidth = "48px";
export const sizeIconHugeHeight = "48px";
export const sizeIconHugeMargin = "12px";
export const sizeIconHugeStrokeWidth = "1.25px";